// extracted by mini-css-extract-plugin
export default {"movie-poster-list":"MoviePosterList_movie-poster-list__XGn-d"};